import ProducerStoreEdit from '@/producers/stores/edit'
import ProducerStoreList from '@/producers/stores/list'
import ProducerStoreCreate from '@/producers/stores/create'
import ProducerStoreShow from '@/producers/stores/show'
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined'

export default {
    icon: StoreOutlinedIcon,
    edit: ProducerStoreEdit,
    list: ProducerStoreList,
    create: ProducerStoreCreate,
    show: ProducerStoreShow
}
